(function () {
  if (window.__ptCustom) return; window.__ptCustom = 1;
  function emit(n, p) { try { if (window.traxEmit) window.traxEmit(n, p); } catch (e) {} }
  function slot(el) { var c = el.closest('[data-ph]'); return c ? c.getAttribute('data-ph') : ''; }
  function part(el) { return el.closest('.pt-c1') ? 'part1' : 'part2'; }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-pt]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (/^(sms|tel):/.test(href) || /direct\.lc\.chat/.test(href)) return;
    var pt = a.getAttribute('data-pt'), ph = slot(a);
    emit('select_promotion', { promotion_id: 'custom-' + pt, promotion_name: ph + '|' + part(a) + '|' + pt, creative_slot: ph, link_url: href || location.pathname });
    if (pt === 'video-play') {
      var id = a.getAttribute('data-v');
      if (!/^[\w-]{6,20}$/.test(id || '')) return;
      var box = document.createElement('div'), f = document.createElement('iframe');
      box.className = 'pt-fv';
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
      f.title = 'A piece being made';
      f.allow = 'autoplay; encrypted-media; picture-in-picture';
      f.allowFullscreen = true;
      box.appendChild(f);
      var fm = a.closest('.pt-fm') || a;
      fm.innerHTML = '';
      fm.appendChild(box);
    }
  }, true);
  var b = document.querySelector('.pt-c1');
  if (b && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) {
        var ph = b.getAttribute('data-ph') || '';
        emit('view_promotion', { promotion_id: 'custom-view', promotion_name: ph + '|part1', creative_slot: ph, link_url: location.pathname });
        io.disconnect(); break;
      }
    }, { threshold: 0.25 });
    io.observe(b);
  }
})();
